<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图" class="logo">
    </div>
    <!-- <p class="title"></p> -->
    <p class="address_tel_fax">
      <span>地址：北京市东城区南竹杆胡同2号银河SOHO B座21003 邮编：10010</span>     
    </p>
    <p class="email_wx">
      <span>Tel：010-59576010/6011</span>
      <span>邮箱：bxet@bx-vision.cn</span>
    </p>
    <div class="copy">
      <p>Copyright &copy; 2009 - 2022 北京芯能电子科技有限公司</p>     
      <p>备案号：京ICP备2021028432号-1</p>
      <div style="width:300px;margin:0 auto;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102006016" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../assets/img/police.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#d3d3d3;">京公网安备 11010102006016号</p >
        </a>
      </div>
    </div>
     

  
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 200px;
  display: block;
  margin:  20px auto 40px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue